var module = 'main', name = 'main/assets/svg/email-icon.svg', content = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg xmlns:xlink=\"http://www.w3.org/1999/xlink\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 18\"><path stroke-linejoin=\"miter\" stroke-linecap=\"butt\" stroke-width=\"1\" stroke=\"#4ac3a8\" fill=\"none\" fill-rule=\"evenodd\" d=\"M 23.5 15.29 C 23.5 16.5 22.51 17.5 21.29 17.5 L 2.71 17.5 C 1.49 17.5 0.5 16.5 0.5 15.29 L 0.5 2.71 C 0.5 1.49 1.49 0.5 2.71 0.5 L 21.29 0.5 C 22.51 0.5 23.5 1.49 23.5 2.71 L 23.5 15.29 L 23.5 15.29 Z M 22.85 1.15 L 13.56 10.44 C 12.7 11.3 11.3 11.3 10.44 10.44 L 1.15 1.15 M 15 9 L 22.85 16.85 L 15 9 Z M 1.15 16.85 L 9 9 L 1.15 16.85 Z M 1.15 16.85\"/></svg>";
angular.module(module).run(['$templateCache', function($templateCache) {
  $templateCache.put(name, content);
}]);
module.exports = name;


//////////////////
// WEBPACK FOOTER
// ./main/assets/svg/email-icon.svg
// module id = 1296
// module chunks = 0